import type {
  ReceivedInvoiceDocumentType,
  ReceivedInvoicePipelineStatus,
  ReceivedInvoiceTaxStatus,
} from "../api/receivedInvoicesApi";

export const DOCUMENT_TYPE_LABEL: Record<ReceivedInvoiceDocumentType, string> = {
  FE: "Factura electrónica",
  NC: "Nota de crédito",
  ND: "Nota de débito",
  TE: "Tiquete electrónico",
  FEC: "Factura de compra",
};

// Pill compacta con la sigla (FE/NC/ND/TE/FEC); el nombre completo va en el
// title para no comerse el ancho de la card a 375px.
export function DocumentTypePill({ type }: { type: ReceivedInvoiceDocumentType | null }) {
  if (type === null) return null;
  return (
    <span
      title={DOCUMENT_TYPE_LABEL[type]}
      className="inline-flex items-center rounded-full bg-app-surface-2 px-2 py-0.5 font-medium font-mono text-[11px] text-app-ink-2"
    >
      {type}
    </span>
  );
}

export const PIPELINE_STATUS_LABEL: Record<ReceivedInvoicePipelineStatus, string> = {
  received: "Esperando factura",
  ready: "Por asignar",
  partially_assigned: "Parcialmente asignada",
  assigned: "Asignada",
  quarantined: "En cuarentena",
  dismissed: "Descartado",
};

const PIPELINE_STATUS_CLASS: Record<ReceivedInvoicePipelineStatus, string> = {
  received: "bg-app-surface-2 text-app-ink-2",
  ready: "bg-app-emerald-bg text-app-emerald",
  partially_assigned: "bg-amber-100 text-amber-800",
  assigned: "bg-app-ink-1/5 text-app-ink-2",
  quarantined: "bg-rose-100 text-rose-700",
  dismissed: "bg-app-surface-2 text-app-ink-3",
};

export function PipelineStatusPill({ status }: { status: ReceivedInvoicePipelineStatus }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 font-medium text-[11px] ${PIPELINE_STATUS_CLASS[status]}`}
    >
      {PIPELINE_STATUS_LABEL[status]}
    </span>
  );
}

// Estado tributario: solo se muestra cuando HAY acuse de Hacienda (v1 lo mueve
// únicamente un MensajeHacienda emparejado por clave). pending_confirmation =
// sin acuse → nada en pantalla.
const TAX_STATUS_LABEL: Record<ReceivedInvoiceTaxStatus, string | null> = {
  pending_confirmation: null,
  accepted: "Aceptada por Hacienda",
  rejected: "Rechazada por Hacienda",
  presumed_accepted: "Aceptada por silencio",
};

const TAX_STATUS_CLASS: Record<ReceivedInvoiceTaxStatus, string> = {
  pending_confirmation: "",
  accepted: "bg-app-emerald-bg text-app-emerald",
  rejected: "bg-rose-100 text-rose-700",
  presumed_accepted: "bg-app-emerald-bg text-app-emerald",
};

export function TaxStatusPill({ status }: { status: ReceivedInvoiceTaxStatus }) {
  const label = TAX_STATUS_LABEL[status];
  if (label === null) return null;
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 font-medium text-[11px] ${TAX_STATUS_CLASS[status]}`}
    >
      {label}
    </span>
  );
}
